<template>
  <Dialog :visible="true" modal :style="{ width: '32rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل قسم الإحصائيات" @update:visible="$emit('close')">
    <div v-for="(item, i) in form.items" :key="i" class="hb-repeat-row">
      <input type="text" class="form-control hb-col-sm" v-model="item.number" placeholder="الرقم" />
      <input type="text" class="form-control" v-model="item.label" placeholder="التسمية" />
    </div>

    <div class="form-field mt-3 hb-visibility">
      <label class="field-label">الحالة</label>
      <InputSwitch v-model="form.is_active" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

export default {
  name: 'StatsEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    const s = this.section.settings || {};
    return {
      form: {
        items: (s.items?.length ? s.items : [{}, {}, {}, {}]).map((it) => ({ number: it.number || '', label: it.label || '' })),
        is_active: !!this.section.is_active,
      },
    };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    async save() {
      try {
        await this.store.updateSection(this.section.id, {
          settings: { items: this.form.items },
          is_active: this.form.is_active,
        });
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
.hb-repeat-row { display: flex; gap: 0.5rem; margin-bottom: 0.5rem; }
.hb-col-sm { max-width: 100px; flex-shrink: 0; }
</style>
